// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiFormControl-root {
  background-color: #e8e8e8;
  border-radius: 10px;
  font-family: "MoscowSans", Arial, sans-serif !important;

  max-width: 140px;
}

.MuiDateCalendar-root {
  height: -webkit-fit-content !important;
  height: -moz-fit-content !important;
  height: fit-content !important;
}

.MuiInputBase-input {
  font-size: 18px !important;
}
.special-color-1 .MuiFormControl-root {
  background-color: #e8e8e8 !important;
}
.special-color-1 .MuiInputBase-input {
  z-index: 2;
  background-color: #e8e8e8 !important;
}

.MuiFormControl-root,
.MuiPickersMonth-root button,
.MuiFormControl-root div,
.MuiPickersToolbar-root span,
.MuiPickersToolbar-root div h4,
.MuiDialogActions-root button {
  font-family: "MoscowSans", Arial, sans-serif !important;
}
.MuiOutlinedInput-notchedOutline {
  border-width: 0 !important;
}
button.Mui-selected {
  background-color: #62a744 !important;
}
button.Mui-selected:hover {
  background-color: #62a744 !important;
}
.Mui-selected {
  background-color: #62a744 !important;
}

@media (max-width: 1400px) {
  .MuiInputBase-root.MuiOutlinedInput-root input {
    text-align: center;
  }
}

@media (max-width: 1024px) {
  .MuiFormControl-root {
    max-width: 90px;
  }
  
  .MuiFormControl-root .MuiInputBase-root {
    padding-right: 0;
  }

  .MuiInputBase-root.MuiOutlinedInput-root input {
    padding: 8px;
    text-align: center;
  }
}

@media (max-width: 540px) {
  .MuiFormControl-root {
    max-width: 80px;
  }

  .MuiInputBase-root.MuiOutlinedInput-root input {
    padding-right: 8px;
    font-size: 14px !important;
  }

  .MuiFormControl-root div {
    padding: 0;
  }

  .MuiFormControl-root div div {
    display: none;
  }

  .MuiFormControl-root div button {
    padding: 0;
    padding-right: 4px;
  }

  .MuiFormControl-root div button svg {
    width: 0.8em;
    height: 0.8em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Filter.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uDAAuD;;EAEvD,gBAAgB;AAClB;;AAEA;EACE,sCAA8B;EAA9B,mCAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;;;;;;EAME,uDAAuD;AACzD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".MuiFormControl-root {\r\n  background-color: #e8e8e8;\r\n  border-radius: 10px;\r\n  font-family: \"MoscowSans\", Arial, sans-serif !important;\r\n\r\n  max-width: 140px;\r\n}\r\n\r\n.MuiDateCalendar-root {\r\n  height: fit-content !important;\r\n}\r\n\r\n.MuiInputBase-input {\r\n  font-size: 18px !important;\r\n}\r\n.special-color-1 .MuiFormControl-root {\r\n  background-color: #e8e8e8 !important;\r\n}\r\n.special-color-1 .MuiInputBase-input {\r\n  z-index: 2;\r\n  background-color: #e8e8e8 !important;\r\n}\r\n\r\n.MuiFormControl-root,\r\n.MuiPickersMonth-root button,\r\n.MuiFormControl-root div,\r\n.MuiPickersToolbar-root span,\r\n.MuiPickersToolbar-root div h4,\r\n.MuiDialogActions-root button {\r\n  font-family: \"MoscowSans\", Arial, sans-serif !important;\r\n}\r\n.MuiOutlinedInput-notchedOutline {\r\n  border-width: 0 !important;\r\n}\r\nbutton.Mui-selected {\r\n  background-color: #62a744 !important;\r\n}\r\nbutton.Mui-selected:hover {\r\n  background-color: #62a744 !important;\r\n}\r\n.Mui-selected {\r\n  background-color: #62a744 !important;\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n  .MuiInputBase-root.MuiOutlinedInput-root input {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .MuiFormControl-root {\r\n    max-width: 90px;\r\n  }\r\n  \r\n  .MuiFormControl-root .MuiInputBase-root {\r\n    padding-right: 0;\r\n  }\r\n\r\n  .MuiInputBase-root.MuiOutlinedInput-root input {\r\n    padding: 8px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 540px) {\r\n  .MuiFormControl-root {\r\n    max-width: 80px;\r\n  }\r\n\r\n  .MuiInputBase-root.MuiOutlinedInput-root input {\r\n    padding-right: 8px;\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .MuiFormControl-root div {\r\n    padding: 0;\r\n  }\r\n\r\n  .MuiFormControl-root div div {\r\n    display: none;\r\n  }\r\n\r\n  .MuiFormControl-root div button {\r\n    padding: 0;\r\n    padding-right: 4px;\r\n  }\r\n\r\n  .MuiFormControl-root div button svg {\r\n    width: 0.8em;\r\n    height: 0.8em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
